import * as React from "react";
import { connect } from "react-redux";

/**
 * This is a base component for any components that need to load data.  Just making a consistent pattern
 * 
 * Also started adding helper methods for data input screens too
 * 
 */
class DataComponent extends React.Component {
    constructor(props) {
        super(props);
        this.privateLoadData = this.privateLoadData.bind(this);
        this.onDobChange = this.onDobChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.bHasWindow = typeof window !== "undefined";
        this._isMounted = false;
        this.state = {
            dataLoaded: false,
            fields: {}
        };
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount();}
        
        this._isMounted = true;
        this.privateLoadData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (super.componentDidUpdate) { super.componentDidUpdate(prevProps, prevState, snapshot); }

        this.privateLoadData();
    }

    componentWillUnmount() {
        if (super.componentWillUnmount) { super.componentWillUnmount(); }
        
        this._isMounted = false;
        const { dataLoaded } = this.state;
        if (dataLoaded) {
            this.setState({ dataLoaded: false });
        }
    }

    privateLoadData() {
        const { dataLoaded } = this.state;
        if (!dataLoaded && this.shouldLoadData && this.shouldLoadData() )
        {
            this.setState({ dataLoaded: true });
            if (this.loadData)
            {
                this.loadData();
            }
        }
    }

    onDobChange(value, inputName) {
        let fields = this.state.fields;
        fields[inputName] = value;
        this.setState({ fields });
        if (this.inputsChanged) {
            this.inputsChanged();
        }
        window.componentChanged = true;
    }

    handleInputChange(e) {
        if (e) {
            const target = e.target;
            let fields = this.state.fields;
            fields[target.name] = e.target.value;
            this.setState({ fields });
            if (this.inputsChanged) {
                this.inputsChanged();
            }
            window.componentChanged = true;
        }
    }

}


export default DataComponent;